import { Pipe, PipeTransform } from '@angular/core';

//
// 1:1 port of ui-select's own "highlight" filter (site/js/select.min.js), used on the
// ui-select-choices option template via `| highlight: $select.search`.
//
@Pipe({ name: 'highlight', pure: true })
export class HighlightPipe implements PipeTransform
{
  transform(text: string | null | undefined, search: string | null | undefined): string | null | undefined
  {
    if (!search || !text) return text;
    const pattern = new RegExp(escapeRegex(search), 'gi');
    return String(text).replace(pattern, '<span class="ui-select-highlight">$&</span>');
  }
}

function escapeRegex(value: string): string
{
  return String(value).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}
